import React from "react";
//#region types
import { SupportRatingResponseProps } from "models/propTypes/supportPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const RatingResponse: React.FC<SupportRatingResponseProps> = (props) => {
  const { messageTitle, messageBody } = props;

  return (
    <Grid container direction="column" alignItems="center" className={cssExports.ratingElement}>
      <label className={cssExports.messageTitle}>{messageTitle}</label>
      <label className={cssExports.messageBody}>{messageBody}</label>
    </Grid>
  );
};

export default RatingResponse;
